import cx from 'classnames'
import Styles from './PlanColumn.module.scss'
import { PaymentPlan } from 'api/clients/PaymentPlanClient'
import { PlanIcon } from 'components/Settings/TieredBilling/components/PlanIcon/PlanIcon'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { BillingFrequency } from 'stores/PaywallStore'

export const PlanHeader = ({
  plan,
  frequency,
  compact = false,
  discount = false,
}: {
  plan: PaymentPlan
  frequency: BillingFrequency
  compact?: boolean
  discount?: boolean
}) => {
  let monthlyPrice =
    frequency === BillingFrequency.MONTHLY ? plan.price.month.unit_amount : plan.price.year.unit_amount / 12

  if (discount && frequency === BillingFrequency.ANNUAL) {
    monthlyPrice = Math.round(monthlyPrice * 0.92)
  } else {
    monthlyPrice = Math.round(monthlyPrice)
  }

  const iconSize = compact ? 20 : 30
  const headingLevel = compact ? 5 : 4

  return (
    <div className={cx(Styles.planHeader, [Styles[plan.key]], compact && Styles.compact)}>
      <div className={Styles.planIconTitle}>
        <PlanIcon size={iconSize} plan={plan.key} />
        <Heading level={headingLevel} color="var(--light-100)">
          {plan.name}
        </Heading>
      </div>
      <Text variant="placeholder" color="var(--light-100)">
        ${monthlyPrice}/mo
      </Text>
    </div>
  )
}
